
const SIZE_CLASSES = {
  xs: 'h-4 w-4',
  sm: 'h-5 w-5',
  md: 'h-8 w-8',
  lg: 'h-12 w-12',
  xl: 'h-16 w-16',
};

const VARIANT_CLASSES = {
  primary: 'border-primary-600',
  dark: 'border-gray-600',
  light: 'border-white',
  purple: 'border-purple-600',
  red: 'border-red-600',
  blue: 'border-blue-600',
  white: 'border-white',
  'blue-400': 'border-blue-400',
};

/**
 * Shared loading spinner.
 * @param {Object} props
 * @param {'xs'|'sm'|'md'|'lg'|'xl'} [props.size='md'] - Spinner size
 * @param {'primary'|'dark'|'light'|'purple'|'red'|'blue'|'white'|'blue-400'} [props.variant='primary'] - Border color variant
 * @param {string} [props.className] - Additional CSS classes
 */
function LoadingSpinner({ size = 'md', variant = 'primary', className = '' }) {
  return (
    <div
      className={`animate-spin rounded-full border-b-2 ${SIZE_CLASSES[size] || SIZE_CLASSES.md} ${VARIANT_CLASSES[variant] || VARIANT_CLASSES.primary} ${className}`.trim()}
      role="status"
      aria-label="Loading"
    />
  );
}

export default LoadingSpinner;
